const KDJ = [
    {id: "0", value: "K"},    
    {id: "1", value: "D"},
    {id: "2", value: "J"}    
  ];  
  
  export default KDJ